import classNames from "classnames";
// React
import React from "react";
import FlexItem from "common/ui/containers/flexContainer/FlexItem";
import HoverInfoWrapper from "common/ui/components/tooltips/HoverInfoWrapper";
//-------------------------------------------------------------------------------------------------------------------------------
// Styles
//-------------------------------------------------------------------------------------------------------------------------------
import styles from "./DataBar.less";
//-------------------------------------------------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------------------------------------------------
export default class DataBarLabel extends React.Component {
    render() {
        let { className, label, toolTip } = this.props;
        if (toolTip) {
            return (React.createElement(FlexItem, { className: classNames(styles.container, className) },
                React.createElement(HoverInfoWrapper, { className: styles.labelContainer, tipText: toolTip },
                    React.createElement("div", { className: styles.bigLabel }, label))));
        }
        else {
            return (React.createElement(FlexItem, { className: classNames(styles.container, className) },
                React.createElement("div", { className: styles.labelContainer },
                    React.createElement("div", { className: styles.bigLabel }, label))));
        }
    }
}
